import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux';
import { thunk } from 'redux-thunk';

import callApiMiddleware from '../middlewares/callApiMiddleware';
import rootReducer from '../reducers';


const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export default function configureStore(preloadedState) {
  const middlewares = [thunk, callApiMiddleware];
  return createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(...middlewares)));
}
